<script setup>
import { KNOLIA } from "../knolia"
import { Gems } from "@/gems"
import { MESSAGES } from "../messages";

async function SendAlertToValidators() {
  Gems.Telegram(MESSAGES.QUESTIONS.SENDING_ALERTS, "tele-info", "", "tele-cancel").then(
    async () => {
      const res = await KNOLIA.CallBackEnd("post", "send-alerts-to-validators")
      if(res.data.error) {
        Gems.Telegram(MESSAGES.ERROR.DEFAULT, 'tele-not-allowed')
        return
      }
      Gems.Telegram(MESSAGES.SUCCESS.SENT, 'tele-success')
    },
    () => {}
  );


}

</script>

<template>
  
  <div class="div-container">

    <div class="w-100 row gx-3 gy-3 justify-content-center align-self-center">
      <div class="col-12 col-md-4">
        <button class="col-12" @click="SendAlertToValidators()" @mouseenter="Gems.Tooltip($event.target, MESSAGES.TOOLTIPS.SEND_ALERT_TO_VALIDATORS, 'tooltip')"
        >ENVIAR ALERTA PARA OS VALIDADORES</button>
      </div>
    </div>

  </div>
  
  <router-view></router-view>
</template>

<style scoped>

.div-container {
  margin: 10% auto;
  flex-direction: column;
  display: flex;
  gap: 13px;
}

</style>
